<template>
  <div class="page" >
    <navigation @click="$report({
      id: 50068,
      args: { step: status }
    })"
    ></navigation>
    <main>
      <div class="page_title">
        <div class="header">
          <img src="./images/logo @2x.png" title="logo" class="head-logo"/>
          <div class="rule-button" @click="goActivityRule">
            <span class="rule-button-icon">?</span>活动规则
          </div>
        </div>
      </div>
      <div class="content">
        <div class="title">现金红包</div>
        <div class="money">{{money}}<span>元</span></div>
        <div class="time" v-if="status===1">{{couponExpire | date('YYYY/MM/DD')}}前完成借款有效</div>
        <div class="find" @click="
          navigateTo({
            h5: ['USED', 'CREDIT_LOCKED', 'TIMEOUT'].includes(couponStatus) ? '/quan/history' : '/quan/list',
          })
        " v-stat="{ id: 50066, args: {step: status} }"
        ><span>查看券包</span></div>
      </div>
    </main>
    <div class="btn"  @click="navigateTo(nextNode)" v-if="status===1"><span>申请提现</span></div>
    <div class="note">
      <img src="./images/img_cttmd@2x.png" title="微信" class="wx-img" @click="copy"/>
    </div>
    <footer>活动所有解释权归天美贷所有</footer>
    <nd-dialog
      v-model="dialog"
      :footer="false"
      :closeBtn="true"
      @close="dialog = false"
    >
      <div class="dialog-content" slot="custom">
        <p>
          抱歉，您当前无法提现！
        </p>
        <p>
          您当前处于封禁期，<br />请于{{
            lockingDay | date('YYYY/MM/DD')
          }}重新发起!
        </p>
        <div
          class="button"
          @click="navigateTo(nextNode,true)"
          v-stat="{ id: 50070 }"
        >
          查看详情
        </div>
      </div>
    </nd-dialog>

  </div>
</template>

<script>
import { jsBridge, hasNativeMethod } from '@/assets/jsBridge'
import { mapState, mapActions } from 'vuex'
import { copyToClipbord } from '@/assets/utils'
import { judgeClientSystem } from '../../../assets/utils'
export default {
  name: 'drainage-activity',
  customReadyNotify: true,
  data () {
    return {
      money: 0,
      status: 1, // 0->未授信，1->授信成功15日内未成功借款，2->授信橙红15日内已成功借款
      activeType: 'DRAINAGE',
      couponStatus: 'PRE_PROVIDE',
      nextStep: null,
      couponExpire: null,
      dialog: false, // 引导授信弹窗
      couponId: null,
      relationId: null
    }
  },
  computed: {
    ...mapState('user', {
      lockingDay: (state) => state.quotaInfo.lockingDay
    }),
    ...mapState({
      statusBarHeight: state => state.statusBarHeight - 15
    }), 
    nextNode () {
      switch (this.nextStep) {
        case 'OCR':
          return { h5: '/authentication/id', native: 'ocr' }
        case 'INFO':
          return { h5: '/authentication/base', native: 'basic_info' }
        case 'CREDIT':
          return {
            h5: '/authentication/base',
            native: 'basic_info'
          }
        case 'CREDIT_REVIEW':
        case 'CREDIT_LOCKED':
          return {
            h5: `/authentication/result?applyNo=${this.relationId}`
          }
        case 'CREDIT_SUCCESS':
          return { h5: '/withdraw/index', native: 'withdraw' }
        case 'LOAN':
          return { h5: '/withdraw/index', native: 'withdraw' }
        case 'LOANING':
        case 'LOAN_LOCKED':
        case 'LOAN_WAIT_VIP':
          return {
            h5: `/withdraw/result?loanApplyNo=${this.relationId}`
          }
        default:
          return { h5: '/authentication/id', native: 'ocr' }
      }
    }
  },
  async created () {
    await this.getActiveDetail()
    await this.getLimitX({ loanPlatform: 'TMD' })
    if (this.couponId) await this.getCouponDetail()
    this.$report({
      id: 10002,
      args: {
        screen: this.status === 1 ? 'page_drainage' : 'page_already_drainage',
        visible: 1
      }
    })
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('user', ['getLimitX']),

    ...mapActions('activities', [
      'qualificationCouponX',
      'couponDetailX',
      'activeCouponX',
      'queryFirstShow'
    ]),
    // 拷贝微信
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
      this.$report({
        id: 50054
      })
    },
    back () {
      this.$report({
        id: 50039, args: { step: this.status }
      })
      if (hasNativeMethod('exit') && judgeClientSystem() !== 'IOS') {
        jsBridge('exit')
      } else {
        this.$router.back()
      }
    },
    goActivityRule () {
      this.$report({
        id: 50067,
        args: { step: this.status }
      })
      this.$router.push(
        `/activities/drainage/rule`
      )
    },
    async getCouponDetail () {
      const res = await this.couponDetailX({
        couponRecordId: this.couponId
      })
      this.couponDetail = res.data || {}
      this.couponStatus = this.couponDetail.status
      this.money = this.couponDetail.discountValue
      this.couponExpire = this.couponDetail.endTime
    },
    async getActiveDetail () {
      const res = await this.qualificationCouponX({
        activeType: this.activeType
      })
                
      if (res.data && res.data[0]) {
        this.qualification = res.data[0].qualification
        this.couponId = res.data[0].couponRecordId
        this.nextStep = res.data[0].nextStep
        this.relationId = res.data[0].relationId
        if (['LOAN_PASSED'].includes(this.nextStep)) {
          this.status = 2
        } else {
          this.status = 1
        }
      }
    },
    navigateTo (path, bool) {
      this.$report({
        id: 50065,
        args: { step: this.status }
      })
      // if (['LOAN_LOCKED', 'CREDIT_LOCKED'].includes(this.nextStep) && !bool) {
      //     this.dialog = true
      //     return 
      // }
      if (hasNativeMethod('navigateTo') && !!path.native && judgeClientSystem() !== 'IOS') {
        jsBridge('navigateTo', { path: path.native, exitCurrent: true })
      } else {
        this.$router.push(path.h5)
      }
    }
  },
  watch: {
    dialog (val) {
      this.$report({
        id: 50069,
        args: {
          visible: val ? 1 : 0
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.page{
    background:#951F21;
    // height: calc(100% - 110px);
    main{
    width: 750px;
    height:1070px;
    background:url("./images/bg_01@2x.png") no-repeat;
    background-size: 100%;
    position: relative;
    top:0;
        .page_title {
        padding: 46px 20px 63px 55px;
        .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height:70px;
        height: 70px;
        .head-logo{
           width: 70px;
           height: 70px; 
        }
        .logo {
            width: 70px;
            height: 70px;
            margin-left: 35px;
        }
        .rule-button {
            display: flex;
            align-items: center;
            font-size: 28px;
            color: rgba(255, 255, 255, 1);
            > span {
                width: 32px;
                height: 32px;
                line-height: 32px;
                margin-right: 5px;
                background-color: rgba(255, 255, 255, 1);
                color: rgb(180,58,65);
                font-weight: 600;
                border-radius: 50%;
                text-align: center;
            }
        }
        }
    }
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        position:relative;
        height:100%;
        .title{
            position:absolute;
            top:215px;
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #AD4B28;
            line-height: 40px;
        }
            .money{
                position:absolute;
                top:255px;
                height: 109px;
                font-size: 90px;
                font-family: DIN-Medium, DIN;
                font-weight: 500;
                color: #AD4B28;
                line-height: 109px;
                span{
                    padding-left:3px;
                    font-size: 28px;
                    font-weight: 400;
                }
            }
            .time{
                position:absolute;
                top:480px;
                width: 168px;
                height: 68px;
                font-size: 24px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #AD4B28;
                line-height: 33px;
            }
            .find{
                position:absolute;
                top:600px;
                width: 191px;
                height: 60px;
                line-height: 60px;
                text-align: center;
                border-radius: 32px;
                border: 2px solid #AD4B28;
                span{
                    height: 40px;
                    font-size: 28px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #AD4B28;
                    line-height: 40px;
                }
            }
        }
    }
    .btn{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index:2;
        margin:-130px auto 170px;
        width: 520px;
        height: 100px;
        line-height: 100px;
        text-align: center;
        background: linear-gradient(180deg, #FCF1AA 0%, #EAA97E 100%);
        border-radius: 55px;
            span{
                height: 56px;
                font-size: 40px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #AD4B28;
                line-height: 56px;
            }
        }
    .note{
    margin:-110px auto 0;
    width: 680px;
    height: 630px;
    background:url("./images/img_gonglue@2x.png");
    background-size: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    img{
        position: absolute;
        bottom:35px;
        width:610px;
        height:88px;
    }
    }
    footer {
        flex-shrink: 0;
        font-size: 22px;
        color: #fff;
        text-align: center;
        padding-top: 89px;
        padding-bottom: 45px;
    }
}
.dialog-content {
    width: 620px;
    height: 450px;
    padding: 0 70px;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    overflow: hidden;
    text-align: center;
    p:nth-child(2) {
        padding-bottom: 66px;
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 42px;
    }
    .dialog2-img{
        margin: 20px 0 38px;
        width: 500px;
        height: 152px;
    }
    p:nth-child(1) {
        font-size: 36px;
        padding:70px 0 60px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 50px;
    }
    .button {
        width: 440px;
        height: 80px;
        line-height: 80px;
        margin:  auto ;
        background: linear-gradient(
            90deg,
            rgba(255, 51, 51, 1) 0%,
            rgba(255, 95, 52, 1) 100%
        );
        border-radius: 40px;
        font-size: 32px;
        color: rgba(255, 255, 255, 1);
    }
}
</style>
